export default __webpack_public_path__ + "static/backup-b91e2acfec1de7e40790c0be6773a59e.jpg";